module.exports = __webpack_public_path__ + "img/alabama-power-logo-main.e801c934.jpg";